function sendPurchaseDataToGTM() {
  window.dataLayer = window.dataLayer || [];
  document.addEventListener('variant:add', (event) => {
    const variant = event.detail.items[0];
    if (!variant) return;
    window.dataLayer.push({
      event: 'EEC-AddToCart',
      value: (variant.price / 100).toFixed(2),
      ecommerce: {
        currencyCode: window.Shopify.currency.active,
        add: {
          products: [
            {
              id: variant.sku,
              sku: variant.sku,
              name: variant.title,
              price: (variant.price / 100).toFixed(2),
              brand: 'Brooklyn Soap Company',
              quantity: variant.quantity,
            },
          ],
        },
      },
      items: [{ id: variant.sku, google_business_vertical: 'retail' }],
    });
  });
}

function openCookiesPreferences() {
  const consentLinks = document.querySelectorAll('[data-consent]');
  if (consentLinks.length === 0) return;
  consentLinks.forEach((link) => {
    link.addEventListener('click', () => {
      _iub.cs.api.openPreferences();
    });
  });
}

function openTaxPopup() {
  if (!location.href.includes('/products')) return;
  const openButton = document.querySelector('[open-tax]');
  const taxPopup = document.querySelector('[tax-popup]');
  if (!openButton || !taxPopup || window.innerWidth > 1023) return;

  document.addEventListener('click', function (e) {
    if (!taxPopup.contains(e.target) && !openButton.contains(e.target)) {
      taxPopup.style.display = 'none';
    }
  });

  openButton.addEventListener('click', () => {
    taxPopup.style.display = 'block';
  });
}

function initTrustbadgeScrollBehavior() {
  function hideOnScroll(el) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 100) {
        el.style.display = 'none';
      } else {
        el.style.display = 'block';
      }
    });
  }

  function observe() {
    const existing = document.querySelector('[id*="trustbadge-container"]');
    if (existing) {
      hideOnScroll(existing);
      return;
    }

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1) {
            const el = node.id?.includes('trustbadge-container') ? node : node.querySelector?.('[id*="trustbadge-container"]');

            if (el) {
              hideOnScroll(el);
              observer.disconnect();
            }
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  observe();
}

function productDiscountBlock() {
  const copyButton = document.querySelector('[data-copy]');
  if (!copyButton) return;
  const discount = copyButton.querySelector('[data-discount]');
  if (!discount) return;
  copyButton.addEventListener('click', () => {
    const discountValue = discount.dataset.discount;
    navigator.clipboard.writeText(discountValue);
    copyButton.classList.add('active');

    setTimeout(() => {
      copyButton.classList.remove('active');
    }, 2500);
  });
}

async function addToCartHandler(event, id) {
  event.preventDefault();
  const url = `${Shopify.routes.root}cart/add.js`;
  let sectionsToBundle = new Set();
  document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
  const formData = {
    items: [
      {
        id: id,
        quantity: 1,
      },
    ],
    sections: [...sectionsToBundle].join(','),
  };

  const request = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(formData),
  };

  const response = await fetch(url, request);
  const result = await response.json();

  if (response.ok) {
    const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    cartContent['sections'] = result['sections'];
    const items = result.hasOwnProperty('items') ? result['items'] : [result];
    document.documentElement.dispatchEvent(
      new CustomEvent('variant:add', {
        bubbles: true,
        detail: {
          items,
          cart: cartContent,
        },
      }),
    );
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'variant:add',
          cart: cartContent,
        },
      }),
    );
  }
}

function customAddToCartFromSection() {
  const atcButtons = document.querySelectorAll('[data-custom-add-to-cart]');
  if (atcButtons.length === 0) return;
  atcButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const id = button.dataset.customAddToCart;
      addToCartHandler(event, id);
    });
  });
}

const ZENDESK_SHOW_DELAY = 6500;

function initZendeskVisibility() {
  const { classList } = document.body;
  const show = () => classList.add('zendesk-visible');

  if (classList.contains('page-index')) {
    const footer = document.querySelector('.footer');
    if (!footer) return show();
    new IntersectionObserver(([entry]) => {
      classList.toggle('zendesk-visible', entry.isIntersecting);
    }).observe(footer);
    return;
  }

  const isDelayedPage = document.body.matches('.page-collection, .page-product, .page-search, .page-blog, .page-article');
  if (!isDelayedPage) return;

  const showWithDelay = () => setTimeout(show, ZENDESK_SHOW_DELAY);
  if (document.readyState === 'complete') {
    showWithDelay();
  } else {
    window.addEventListener('load', showWithDelay, { once: true });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initZendeskVisibility();
  openCookiesPreferences();
  sendPurchaseDataToGTM();
  openTaxPopup();
  initTrustbadgeScrollBehavior();
  productDiscountBlock();
  customAddToCartFromSection();
});

if (!customElements.get('product-card-slider')) {
  customElements.define(
    'product-card-slider',
    class ProductCardSlider extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector('.swiper');
      }
      connectedCallback() {
        this.initSlider();
      }

      initSlider() {
        if (!this.slider || window.innerWidth > 999) return;
        const options = {
          slidesPerView: 1,
          slidesPerMove: 1,
          pagination: {
            el: this.slider.querySelector('.swiper-pagination'),
            type: 'bullets',
            clickable: true,
          },
        };

        new window.Swiper(this.slider, options);
      }
    },
  );
}
